import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import TextInput from 'src/components/TextInput';

const BulkAddFieldCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const { showPreview, appendLineItem, value, title } = dataItem;
  const isDisabled = !dataItem.selected;

  return (
    <GridCellBase
      {...props}
      className={`!bg-transparent !flex ${
        showPreview && value && appendLineItem && !isDisabled ? 'h-[62px]' : ''
      }`}
      title={title}
    >
      <div className="w-full">
        <TextInput type={'text'} className="!text-black !opacity-100" value={title} disabled />
      </div>
    </GridCellBase>
  );
};

export default BulkAddFieldCell;
